import React, { createRef } from 'react'
import { Button, Message, Grid, Dropdown } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import OrgUnitUserSearchTable from './../drive/AddUserSearchTable'
import { singleLineText } from '../../../common/RegexValidation';
import BreadCrumbOrganization from './cards/BreadCrumbOrganization';


let payload = {};
let inviteSearchObject = {
    firstName: "",
    lastName: "",
    email: "",
    role: ""
}
class AddUsers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            noRecord: false,
            checkValid: true,
            setRole: '',
            invitationError: null,
            teamId: null,
            teamDropdownDisableFlag: false
        }
        this.handleInviteSearch = this.handleInviteSearch.bind(this);
        this.handleTeam = this.handleTeam.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.firstNameRef=createRef();
        this.lastNameRef=createRef();
        this.emailRef=createRef();
    }
    componentWillMount() {
        this.getStart();
    }

    async getStart() {
        dispatch.invite.setError(null);
        dispatch.community.addMainAreaContext('InviteAndAddUsers');
        dispatch.invite.clearInviteSearchFilter();
        this.setState({ noRecord: false, checkValid: true })

        if (this.state.setRole !== 'workspaceOwner') {
            let payload = {};
            payload.id = this.props.match.params.workspaceId;
            payload.teamlist = true;
            await dispatch.initiatives.getTeamsUnderManager(payload);
        }

        if (this.props.match.params.teamId && this.props.match.params.workspaceId === this.props.match.params.teamId) {
            await dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
        }
        else if (this.props.match.params.teamId && this.props.match.params.workspaceId !== this.props.match.params.teamId) {
            this.setState({ 'teamDropdownDisableFlag': true, teamId: this.props.match.params.teamId })
            await dispatch.organizationUnit.getSubOrgByIdAsync(this.props.match.params.teamId);
        }
        else {
            this.setState({ 'teamDropdownDisableFlag': true, teamId: this.props.selectedSubOrg._id })
            await dispatch.organizationUnit.getSubOrgByIdAsync(this.props.selectedSubOrg._id);
        }

    }

    componentDidMount() {
        document.getElementById("invitationForm").reset();
    }


    handleChange(data) {
        this.setState({ setRole: data.target.value })
    }

    async handleTeam(values, data) {
        this.setState({ setRole: '' })
        this.setState({ 'teamId': data.value });
        payload = {};
        if (data.value === null) {
            await dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
            payload.value = inviteSearchObject;
            payload.accountId = this.props.match.params.accountId;
            payload.organizationId = this.props.match.params.workspaceId;
            payload.referenceCollection = "organizations";
            payload.referenceId = this.props.match.params.workspaceId;
            payload.addedUsersArray = this.props.selectedSubOrg && this.props.selectedSubOrg.users && this.props.selectedSubOrg.users.length > 0 ? this.props.selectedSubOrg.users.map((user) => { return user.accountUserId }) : [];
        }
        else {
            await dispatch.organizationUnit.getSubOrgByIdAsync(data.value);
            payload.value = inviteSearchObject;
            payload.accountId = this.props.match.params.accountId;
            payload.organizationId = this.props.match.params.workspaceId;
            payload.referenceCollection = "suborganizations";
            payload.referenceId = this.props.selectedSubOrg._id;
            payload.addedUsersArray = this.props.selectedSubOrg && this.props.selectedSubOrg.members && this.props.selectedSubOrg.members.length > 0 ? this.props.selectedSubOrg.members.map((members) => { return members.accountUserId }) : [];

        }
        dispatch.invite.getSearchedInviteUsers(payload);
    }

    handleInviteSearch(data) {
        this.setState({ noRecord: true })
        payload = {};
        inviteSearchObject[data.target.name] = data.target.value;
        if (inviteSearchObject.firstName && inviteSearchObject.lastName && inviteSearchObject.email) {
            this.setState({ checkValid: false });
        }
        else {
            this.setState({ checkValid: true });
        }
        payload.value = inviteSearchObject;
        payload.accountId = this.props.match.params.accountId;
        payload.organizationId = this.props.match.params.workspaceId;
        if (this.state.teamDropdownDisableFlag || this.state.teamId !== null) {
            payload.referenceCollection = "suborganizations";
            payload.referenceId = this.state.teamId;
            payload.addedUsersArray = this.props.selectedSubOrg && this.props.selectedSubOrg.members && this.props.selectedSubOrg.members.length > 0 ? this.props.selectedSubOrg.members.map((members) => { return members.accountUserId._id ? members.accountUserId._id : members.accountUserId }) : [];
        }
        else {
            if (this.props.match.params.workspaceId === this.props.match.params.teamId) {
                payload.referenceCollection = "organizations";
                payload.referenceId = this.props.match.params.workspaceId;
                payload.addedUsersArray = this.props.selectedSubOrg && this.props.selectedSubOrg.users && this.props.selectedSubOrg.users.length > 0 ? this.props.selectedSubOrg.users.map((user) => { return user.accountUserId }) : [];
            }
            else {
                payload.referenceCollection = "suborganizations";
                payload.referenceId = this.props.selectedSubOrg._id;
                payload.addedUsersArray = this.props.selectedSubOrg && this.props.selectedSubOrg.members && this.props.selectedSubOrg.members.length > 0 ? this.props.selectedSubOrg.members.map((members) => { return members.accountUserId._id ? members.accountUserId._id : members.accountUserId }) : [];
            }
        }
        dispatch.invite.getSearchedInviteUsers(payload);
    }

    async  onSubmitInviteUserSubUnit(formData) {
        if (!this.state.setRole || formData.firstName === undefined || formData.lastName === undefined || formData.email === undefined) {
            this.setState({ checkValid: true });
        } else {
            formData.role = this.state.setRole;
            formData.organizationId = this.props.match.params.workspaceId;
            formData.from = this.props.user._id;
            formData.accountId = this.props.match.params.accountId;
            formData.teamName = this.props.selectedSubOrg.name;
            formData.String = "ChckBeforeCreateInvite";

            if (this.state.teamDropdownDisableFlag || this.state.teamId !== null) {
                formData.referenceId = this.props.selectedSubOrg._id
                formData.referenceCollection = 'suborganizations';
                formData.StrType = 'createInviteForOrgToSubOrgInvitation';
            }
            else if (this.state.teamId === null) {
                formData.referenceId = this.props.match.params.workspaceId;
                formData.referenceCollection = 'organizations';
            }


            try {
                await dispatch.invite.createInvitationAsync(formData);
                dispatch.community.addMainAreaContext('USERS');
                this.handleReset();
                if (this.props.stringType === 'TeamMapping' || this.props.stringType === 'SubOrgUserAddModal') {
                    this.props.onClose();
                    dispatch.initiatives.getInviteBySubOrgAsync(formData.referenceId)
                }
                else {
                    let query = {
                        $sort: { createdAt: 1 },
                        $skip: 0,
                        $limit: this.props.teamsListViewFlag ? 10 : 50
                    }
                    let payload = {
                        query: query,
                        organizationId: this.props.selectedOrganisation.id,
                        referenceId: formData.referenceId
                    };
                    await dispatch.invite.getInvitesAsync(payload);
                    await dispatch.users.userTreeSelectedPath("1")
                    await dispatch.invite.storeUserRole('Invitations');
                    await dispatch.users.storeUnitId(formData.referenceId);
                    this.props.history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/userList/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/Invitations`);
                }
            }
            catch (err) {
                this.setState({ "invitationError": err })
            }
        }

    }

    handleReset() {
        document.getElementById("invitationForm").reset();
        dispatch.invite.clearInviteSearchFilter();
        this.setState({ setRole: '', invitationError: null })
        this.setState({ noRecord: false })
        if (!this.state.checkValid) {
            this.setState({ checkValid: true })
        }
        if (this.props.selectedSubOrg._id.toString() === this.props.match.params.workspaceId.toString()) {
            this.setState({ teamId: null })
        }
        else {
            this.setState({ teamId: this.props.match.params.teamId ? this.props.match.params.teamId : this.props.selectedSubOrg && this.props.selectedSubOrg._id })
        }

        inviteSearchObject = {
            firstName: "",
            lastName: "",
            email: "",
            role: ""
        }

    }

    handleCancel(e) {
        this.handleReset()
        const history = this.props.history;
        if (this.props.addUserContext === 'Teams') {
            dispatch.community.addMainAreaContext('ORGANIZATION');
            history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/team/${this.props.match.params.parentOrganizationId}`);
        }
        else if (this.props.addUserContext === 'Users') {
            dispatch.community.addMainAreaContext('USERS');
            history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/userList/${this.props.selectedSubOrg._id}/users`);
        }
    }

    handleClose(e) {
        dispatch.community.addMainAreaContext('ORGANIZATION');
        this.handleReset();
        this.props.onClose();
    }



    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <div >
                {this.props.stringType === 'TeamMapping' || this.props.stringType === 'SubOrgUserAddModal' ?
                    <span className='primary'>Add / Invite User</span> :
                    <BreadCrumbOrganization {...this.props} />}
                <Form noValidate
                    className="invitationForm"
                    id='invitationForm'
                    ref={ref => this.form = ref}
                    onValidSubmit={(formData) => { this.onSubmitInviteUserSubUnit(formData) }}
                >
                    <Grid className="inviteForm">
                        <Grid.Row style={{display:"flex",alignItems:"baseline"}}>
                            <Grid.Column width={5} style={{display:"flex",flexDirection:"column"}}>
                                <label htmlFor='firstName'>First Name
                                    <span style={{color:"red", position: "relative", top: "-2px", left:"5px"}}>*</span>
                                </label>
                                <Form.Input
                                    name="firstName"
                                    id="firstName"
                                    placeholder="Enter First Name"
                                    required    
                                    onChange={this.handleInviteSearch}
                                    errorLabel={errorLabel}
                                    validations={{ matchRegexp: singleLineText }}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128.No numbers or special characters allowed. No space allowed in starting.',
                                        isDefaultRequiredValue: 'First name is required',
                                    }}
                                    instantValidation
                                    autoFocus
                                    style={{ marginTop: "4px" }}
                                />
                            </Grid.Column>

                            <Grid.Column width={5} style={{display:"flex",flexDirection:"column"}}>
                                <label htmlFor='lastName'>Last Name
                                    <span style={{color:"red", position: "relative", top: "-2px", left:"5px"}}>*</span>
                                </label>
                                <Form.Input
                                    name="lastName"
                                    id="lastName"
                                    placeholder="Enter Last Name"
                                    required
                                    onChange={this.handleInviteSearch}
                                    errorLabel={errorLabel}
                                    validations={{ matchRegexp: singleLineText }}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128.No numbers or special characters allowed. No space allowed in starting.',
                                        isDefaultRequiredValue: 'Last Name is required',
                                    }}
                                    instantValidation
                                    style={{ marginTop: "4px" }}
                                />
                            </Grid.Column>

                            <Grid.Column width={6} style={{display:"flex", flexDirection:"column"}}>
                                <label htmlFor='email'>Email
                                   <span style={{color:"red", position: "relative", top: "-2px", left:"5px"}}>*</span>
                                </label>
                                <Form.Input
                                    name="email"
                                    id="email"
                                    placeholder="Email"
                                    required
                                    validations="isEmail"
                                    icon="envelope"
                                    iconPosition="left"
                                    onChange={this.handleInviteSearch}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        isEmail: 'This is not a valid email',
                                        isDefaultRequiredValue: 'Email is required',
                                    }}
                                    instantValidation
                                    style={{ marginTop: "4px" }}
                                />
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                            <Grid.Column width={5}>
                                <div>
                                    <label className="custom-label" style={{ "margin": "0 0 4px 0 " }}>Team
                                    {this.state.setRole === 'Manager' ?
                                            <span className="clr-red">*</span> : ''}
                                    </label><br />
                                    <Dropdown
                                        name="singleSelectWithDefaultValue"
                                        placeholder="Search Team"
                                        search
                                        selection
                                        //defaultValue={this.props.match.params.teamId ? this.props.match.params.teamId : this.props.selectedSubOrg && this.props.selectedSubOrg._id}
                                        value={this.state.teamId}
                                        required
                                        style={{ "cursor": "pointer", "width": "100%" }}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'You need to select a Team',
                                        }}
                                        errorLabel={errorLabel}
                                        options={this.props.teamList}
                                        disabled={this.state.teamDropdownDisableFlag}
                                        onChange={(values, value) => { this.handleTeam(values, value) }}
                                    />
                                </div>


                            </Grid.Column>
                            <Grid.Column width={5}>
                                {this.props.searchUserArr && this.props.searchInviteUserArr && this.props.searchUserArr.length === 0 && this.props.searchInviteUserArr.length === 0 && !this.state.checkValid ?
                                    <Form.Field
                                        placeholder='Role'
                                        name='role'
                                        id='Role'
                                        required
                                        label='Role'
                                        control='select'
                                        value={this.state.setRole}
                                        onChange={this.handleChange}
                                        style={{ "cursor": "pointer", "width": "100%", "margin": "-4px 1px 4px " }}
                                    >
                                        <option value=''>Select</option>
                                        {!this.state.teamDropdownDisableFlag && this.state.teamId === null ?
                                            <option value="workspaceOwner">Workspace Owner</option>
                                            : ''}
                                        {this.state.teamId !== null || this.state.teamDropdownDisableFlag ?
                                            <option value='Manager'>Manager</option>
                                            : ''}
                                        <option value='Member'>Member</option>
                                    </Form.Field>
                                    : ''}
                            </Grid.Column>

                            <Grid.Column width={6} >
                                <div
                                    className="actionInFormcy border-none pad_0"
                                    style={{ "margin": "20px 0 0 0 ", "float": "right" }}
                                >
                                    <Button
                                        id='submitBtn'
                                        className="button-submit float-right"
                                        type="submit"
                                        disabled={(this.props.searchUserArr && this.props.searchUserArr.length !== 0) || (this.props.searchInviteUserArr && this.props.searchInviteUserArr.length !== 0) || this.state.checkValid || !this.state.setRole}>
                                        Invite</Button>
                                    <Button
                                        id='resetBtn'
                                        className="button-cancel float-right"
                                        onClick={() => this.handleReset()}
                                        type="button">Reset</Button>
                                    {this.props.stringType === 'TeamMapping' || this.props.stringType === 'SubOrgUserAddModal' ?
                                        <Button
                                            id='closeBtn'
                                            className="button-cancel"
                                            onClick={(e) => this.handleClose(e)}
                                            type="button">Close</Button>
                                        :
                                        <Button
                                            id='cancelBtn'
                                            className="button-cancel"
                                            onClick={(e) => this.handleCancel(e)}
                                            type="button">Cancel</Button>
                                    }
                                </div>
                            </Grid.Column>


                        </Grid.Row>
                    </Grid>

                </Form>
                {this.props.searchUserArr && this.props.searchInviteUserArr && (this.props.searchUserArr.length > 0 || this.props.searchInviteUserArr.length) > 0 ?
                    <OrgUnitUserSearchTable
                        searchUserArr={this.props.searchUserArr}
                        searchInviteUserArr={this.props.searchInviteUserArr}
                        user={this.props.user} {...this.props}
                        organizationId={this.props.match.params.workspaceId}
                        selectedSubOrg={this.props.selectedSubOrg}
                        handleReset={() => this.handleReset()}
                        teamDropdownDisableFlag={this.state.teamDropdownDisableFlag}
                        teamId={this.state.teamId}
                        selectedOrganisation={this.props.selectedOrganisation}
                        subOrgs={this.props.subOrgs}
                    />
                    : this.state.noRecord && this.state.invitationError === null ?
                        <Message
                            color='yellow'
                            className="inviteWarning">
                            <p>
                                User not found. Please enter details to invite the user.
                           </p>
                        </Message>
                        : ''}

                {this.state.invitationError && this.state.invitationError.code == 409 ?
                    <Message
                        error
                        className="inviteWarning"
                        content="Given Email-Id already invited."
                    />
                    : this.state.invitationError && this.state.invitationError.message ?
                        <Message
                            error
                            className="inviteWarning"
                            content={this.state.invitationError.message}
                        /> : ''}
            </div>
        )
    }
}

export default withRouter(AddUsers)